<a *ngIf="globals.isCompany()" routerLink="/company-overview" class="workspace-brand" aria-label="Innporting"><img src="assets/img/innporting-logo.svg" alt=""><span class="innporting-wordmark">Innporting</span></a>
<div *ngIf="!globals.isCompany()" class="logo overflow-hidden">
  <a [routerLink]="globals.isCompany() ? '/company-overview' : '/forwarder-overview'" class="simple-text logo-mini" aria-label="Innporting">
    <div class="logo-img">
      <img src="/assets/img/innporting-logo.svg" alt=""/>
    </div>
  </a>
  <a [routerLink]="globals.isCompany() ? '/company-overview' : '/forwarder-overview'" class="simple-text logo-normal">
    Innporting
  </a>
</div>

<div class="sidebar-wrapper">

  <ul class="nav sidebar-primary-nav">
    <ng-container *ngFor="let menuitem of menuItems">
      <li routerLinkActive="active" class="nav-item" id="{{menuitem.id}}" ariaCurrentWhenActive="page">
        <!--If is a single link-->
        <a [routerLink]="[menuitem.path]" [attr.aria-label]="menuitem.title | translate" *ngIf="menuitem.type === 'link'" class="nav-link" (click)="logoutChatQB()"
           [matTooltip]="menuitem.title | translate" matTooltipPosition="right" matTooltipClass="sidebar-tooltip" [matTooltipDisabled]="!collapsed">
          <i class="material-icons notranslate" aria-hidden="true">{{menuitem.icontype}}</i>
          <p>{{menuitem.title | translate}}</p>
        </a>
        <!--If it have a submenu-->
        <a data-toggle="collapse" href="#{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'" (click)="updatePS()"
           class="nav-link">
          <i class="material-icons notranslate" aria-hidden="true">{{menuitem.icontype}}</i>
          <p>{{menuitem.title | translate}}<b class="caret"></b></p>
        </a>
        <!--Display the submenu items-->
        <div id="{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
          <ul class="nav">
            <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
              <a [routerLink]="[menuitem.path, childitem.path]" class="nav-link">
                <span class="sidebar-mini">{{childitem.ab}}</span>
                <span class="sidebar-normal">{{childitem.title}}</span>
              </a>
            </li>
          </ul>
        </div>
      </li>
      <!-- Mobile: "Mi cuenta" closes the first group (the header avatar is hidden there). -->
      <li *ngIf="menuitem.id === 'my-company-tab'" routerLinkActive="active" class="nav-item sidebar-account-item" ariaCurrentWhenActive="page">
        <a class="nav-link" [routerLink]="myAccountRoute" [attr.aria-label]="'MENU_COMPANY.MY_ACCOUNT' | translate" (click)="logoutChatQB()">
          <img class="sidebar-account-avatar" alt=""
               [appUserAvatar]="globals.avatar ? globals.getEnvironment().baseApiUrl + 'files/' + globals.avatar : null"
               [avatarSeed]="globals.userId">
          <p>{{'MENU_COMPANY.MY_ACCOUNT' | translate}}</p>
        </a>
      </li>
    </ng-container>
  </ul>
  <ul class="nav sidebar-session-actions">
    <li class="nav-item">
      <button type="button" class="nav-link" (click)="lock()"
              [attr.aria-label]="'MENU_COMPANY.LOCK' | translate"
              [matTooltip]="'MENU_COMPANY.LOCK' | translate" matTooltipPosition="right" matTooltipClass="sidebar-tooltip" [matTooltipDisabled]="!collapsed">
        <i class="material-icons notranslate" aria-hidden="true">lock</i>
        <span class="sidebar-session-label">{{'MENU_COMPANY.LOCK' | translate}}</span>
      </button>
    </li>
    <li class="nav-item">
      <button type="button" class="nav-link" (click)="signOut()"
              [attr.aria-label]="'MENU_COMPANY.SIGN_OUT' | translate"
              [matTooltip]="'MENU_COMPANY.SIGN_OUT' | translate" matTooltipPosition="right" matTooltipClass="sidebar-tooltip" [matTooltipDisabled]="!collapsed">
        <i class="material-icons notranslate" aria-hidden="true">logout</i>
        <span class="sidebar-session-label">{{'MENU_COMPANY.SIGN_OUT' | translate}}</span>
      </button>
    </li>
  </ul>
</div>
